import React, { useState, useEffect } from 'react'
import styled from 'styled-components';
import { SignOutButton } from './SignOutButton';
import SEKLogo from './icons/SEKLogo';
import { Link, useLocation } from 'react-router';
import { Color, Colors } from '../styles/Colors';
import { MenuButton } from '../styles/Buttons';
import HomeIcon from './icons/HomeIcon';
import AgendaDocsIcon from './icons/AgendaDocsIcon';
import { useUser } from '../context/UserContext';
import ReportDocsIcon from './icons/ReportDocsIcon';
import { ProposalDocsIcon } from './icons/ProposalDocsIcon';
import PublicationDocsIcon from './icons/PublicationDocsIcon';
import AnnualReportIcon from './icons/AnnualReportIcon';
import QuarterlyReportIcon from './icons/QuarterlyReportIcon';
import StandardsPublishIcon from './icons/StandardsPublishIcon';
import SignInIcon from './icons/SignInIcon';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;  
    justify-content: flex-start; 
    align-items: flex-start; 
    padding: 1rem 0.5rem 1rem 0.5rem; 
    background-color: rgba(216, 216, 216, 0.5);  
    position: sticky; 
    top: 0;
    left: 0; 
    height: 100vh; 

    & > div {
        display: flex; 
        flex-direction: column; 
        justify-content: center; 
        align-items: center; 
        width: 100%;
        border-top: 1px solid ${Color(Colors.black)};
        padding: 1rem 0 0 0; 
    }

    
    & > a {
        & > svg {
            width: 100%; 
            height: 48px; 
        }
    }
    
    @media (max-width: 1150px) {
        & > a {
            & > svg {
                height: 42px; 
            }
        }

        & > div {
            max-width: 5rem; 
        }
       
        align-items: center; 
    }

`;

const SubLinks = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    width: calc(100% - 1rem);
    margin-left: 1rem; 
    max-height: ${({ $isOpen }) => $isOpen ? '300px' : '0'}; 
    overflow: hidden;
    opacity: ${({ $isOpen }) => $isOpen ? '1' : '0'}; 
    transition: opacity 200ms ease-out, max-height 200ms ease-out; 
    border-radius: 4px;
`;


const Menu = () => {
    const { roles } = useUser();
    const location = useLocation();
    const isReportRoute = location.pathname.startsWith('/report-tools');
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setIsOpen(isReportRoute);
    }, [isReportRoute])

    return (
        <Wrapper>
            <Link
                style={{ margin: '0 0 1rem 0' }}
                to='/'
            >
                <SEKLogo />
            </Link>
            <div>
                <SignOutButton />
                <MenuButton
                    className={({ isActive }) => (isActive ? 'active' : undefined)}
                    to='/'
                    end
                >
                    <HomeIcon />
                    <span>Start</span>
                </MenuButton>
                {roles && roles.includes('Agenda') && (
                    <MenuButton
                        data-scale="true"
                        className={({ isActive }) => (isActive ? 'active' : undefined)}
                        to='/generate-agenda'
                        end
                    >
                        <AgendaDocsIcon />
                        <span>Agendagenerator</span>
                    </MenuButton>
                )}
                {roles && roles.includes('Report') && (
                    <>
                        <MenuButton
                            data-scale="true"
                            className={({ isActive }) => (isActive ? 'active' : undefined)}
                            to='/report-tools'
                            end
                        >
                            <ReportDocsIcon />
                            <span>Rapportgenerator</span>
                        </MenuButton>

                        <SubLinks $isOpen={isOpen}>
                            <MenuButton
                                data-scale="true"
                                className={({ isActive }) => (isActive ? 'active' : undefined)}
                                to='/report-tools/proposal-report'
                            >
                                <ProposalDocsIcon />
                                <span>Förslagslista</span>
                            </MenuButton>
                            <MenuButton
                                data-scale="true"
                                className={({ isActive }) => (isActive ? 'active' : undefined)}
                                to='/report-tools/publication-report'
                            >
                                <PublicationDocsIcon />
                                <span>Publiceringslista</span>
                            </MenuButton>
                            <MenuButton
                                data-scale="true"
                                className={({ isActive }) => (isActive ? 'active' : undefined)}
                                to='/report-tools/annual-report'
                            >
                                <AnnualReportIcon />
                                <span>Årsrapport</span>
                            </MenuButton>
                            <MenuButton
                                data-scale="true"
                                className={({ isActive }) => (isActive ? 'active' : undefined)}
                                to='/report-tools/quarterly-report'
                            >
                                <QuarterlyReportIcon />
                                <span>Sammanställning (kvartal)</span>
                            </MenuButton>
                            {/* 
                                <MenuButton
                                    data-scale="true"
                                    className={({ isActive }) => (isActive ? 'active' : undefined)}
                                    to='/report-tools/standards-publish'
                                >
                                    <StandardsPublishIcon />
                                    <span>Fastställda standarder (Elsäkerhetsverket)</span>
                                </MenuButton>
                            */}
                        </SubLinks>
                    </>
                )}
                {roles && roles.includes('Visma') && (
                    <MenuButton
                        className={({ isActive }) => (isActive ? 'active' : undefined)}
                        to='/visma'
                    >
                        <SignInIcon />
                        <span>Visma</span>
                    </MenuButton>
                )}
            </div>
        </Wrapper>
    )
}

export default Menu